import React from 'react'
import PropTypes from 'prop-types'

const FontItalicControl = ({ canvas, selectedFont, active, disabled }) => {
  const activeClass = active ? 'active' : ''
  const disabledClass = disabled ? 'disabled' : ''

  const toggleBold = () => {
    if (disabled) {
      return
    }

    const obj = canvas.getActiveObject()
    const isDefault = obj.fontWeight === selectedFont.regular

    obj.set('fontWeight', isDefault ? selectedFont.bold : selectedFont.regular)
      .exitEditing()
    canvas.renderAll()
  }

  return (
    <div
      className={`letterHeaderTools_action icon icon-bold ${activeClass} ${disabledClass}`}
      onClick={toggleBold} />
  )
}

FontItalicControl.propTypes = {
  canvas: PropTypes.object,
  selectedFont: PropTypes.object,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
}

export default FontItalicControl
